<template>
    <v-form-group :label="label"
                  :description="description"
                  :state="errorState">
        <date-picker :value="input"
                     :readonly="readonly"
                     display-format="YYYY-MM-DD"
                     @input="handleInput"></date-picker>
    </v-form-group>
</template>

<script>
    import field from "../../Mixins/field"
    import DatePicker from 'vue-date-pick'

    export default {
        components: {DatePicker},
        mixins: [field],
        methods: {
            handleInput(input) {
                this.input = input
                this.$emit('input', input)
            }
        }
    }
</script>